var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header',{attrs:{"title":_vm.$t('lang.about_title')}}),_c('div',{staticClass:"make"},[_c('img',{attrs:{"src":require("../../assets/img/download/logo.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('lang.about_p1')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }